export const info = (message, ...args) => {
    console.log(message, ...args);
};
export const getErrorMessage = (err) => {
    if (typeof err === "string") {
        return err || "{empty string}";
    }
    if (err instanceof Error) {
        return [err.message, err.stack ?? "No Stack"].join("\n");
    }
    if (!err) {
        return String(err);
    }
    return JSON.stringify(err, null, 2);
};
export const error = (...errs) => {
    console.error(...errs);
};
export const warn = (message, ...args) => {
    console.warn(message, ...args);
};
//# sourceMappingURL=log.js.map